export const SECONDS = 5;
